import { useQuery } from "@tanstack/react-query";
import { useServices } from "index";
import { sortByString } from "utilities/dataSorters";

export const useGetPartners = () => {
  const partnersService = useServices().partnersService;
  return useQuery({
    queryKey: ['partners'],
    queryFn: async () => {
      const response = await partnersService.getPartners();
      return sortByString(response, 'fullName', 'ASCENDING');
    },
    refetchOnWindowFocus: false,
  })
}